module.exports = __webpack_public_path__ + "img/aw.264d8bfe.svg";